<template>
  <v-flex xs12 sm8 md4>
    <v-layout column align-center fill-height>
      <v-flex style="width:100%;">
        <v-card class="elevation-5">
          <v-card-text>
            <v-form ref="form" v-model="formValid">
              <v-text-field autocomplete="new-password" ref="userName" v-model="userName" prepend-icon="mdi-account-outline" name="userName" label="Имя пользователя" type="text" :rules="[rules.required]" @input="checkAttributes()"></v-text-field>
              <v-text-field ref="email" v-model="email" prepend-icon="mdi-email-outline" name="mail" label="E-mail" type="email" :rules="[rules.required, rules.email]" @input="checkAttributes()"></v-text-field>
              <v-text-field autocomplete="new-password" v-model="password" prepend-icon="mdi-lock" name="password" label="Пароль" type="password" :rules="[rules.required]"></v-text-field>
            </v-form>
            <v-checkbox v-model="registerLegal" label="Зарегистрировать организацию"></v-checkbox>
            <v-text-field v-model="legalInn" prepend-icon="mdi-domain" label="ИНН" :rules="[rules.inn]" :disabled="!registerLegal" @input="legalInnInput()"></v-text-field>
            <div class="ml-4 text-xs-left" v-if="legalErrorText && legalErrorText !== ''">
              {{ legalErrorText }}
            </div>
            <div v-else class="ml-4 font-weight-medium">{{ legalName }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat :disabled="!formValid || (registerLegal && !legalCanRegister)" @click.stop="registerAccount()">Зарегистрироваться</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex style="margin-top:14px;">
        <span style="margin-right:6px;">Уже есть учетная запись?</span>
        <a @click.stop="$router.push('/login')">Войти</a>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import Rules from "../rules.js"
export default {
  name: 'register',
  data: function() {
    return {
      formValid: false,
      userName: "",
      email: "",
      password: "",
      registerLegal: false,
      legalInn: '',
      legalName: '',
      legalErrorText: '',
      legalCanRegister: false,
      rules: Rules,
      invalidAttributesMsg: "Имя пользователя или email уже используются"
    }
  },
  methods: {
    checkAttributes() {
      if ((this.userName == this.$store.state.invalidAttributes.userName) && (this.email == this.$store.state.invalidAttributes.email) && (this.userName != "")) {
        this.$refs.userName.errorMessages = this.invalidAttributesMsg;
        this.$refs.email.errorMessages = this.invalidAttributesMsg;
      } else {
        if (this.$refs.userName.errorMessages == this.invalidAttributesMsg) {
          this.$refs.userName.errorMessages = null;
        }
        if (this.$refs.email.errorMessages == this.invalidAttributesMsg) {
          this.$refs.email.errorMessages = null;
        }
      }
    },
    async registerAccount() {
      if (!this.formValid) {
        return;
      }
      let result = await this.$store.dispatch("registerAccount", {
        userName: this.userName,
        email: this.email,
        password: this.password,
        legalInn: this.legalInn,
        type: this.$store.state.loginType
      });
      if (result.status !== 200) {
        this.checkAttributes();
      } else {
        if (this.$store.state.loginType === 'responseCode') {
          await this.$store.dispatch('genResponseCode')
        }
        this.$router.push("/");
      }
    },
    async legalInnInput () {
      this.legalName = ''
      this.legalErrorText = ''
      this.legalCanRegister = false
      if (this.rules.inn(this.legalInn) !== true) {
        return
      }
      const response = await coreAPIClient.post('/api/v1/findCompany', { inn: this.legalInn })
      if (response.data.valid) {
        this.legalName = response.data.name
        this.legalCanRegister = response.data.canRegister
        if (this.legalCanRegister) {
          this.legalErrorText = ''
        } else {
          this.legalErrorText = 'Организация с данным ИНН уже зарегистрирована'
        }
      } else {
        this.legalErrorText = 'Организация не найдена'
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Register.vue?f65d4cce